<template>
    <div class="wizard-wrapper" :id="'wizard-wrapper-'+this.id">
        <div class="row wizard-main">
            <div class="col-lg-7 col-md-12 col-sm-12 wizard-left">
                <img class="wizard-image d-none d-lg-block" src="/images/cashouse_logo.png">
                <img class="wizard-image d-block d-lg-none" src="/images/cashouse_logo_mobile.png">
            </div>
            <div class="col-lg-5 col-md-12 col-sm-12 wizard-right"></div>
            <div class="row wizard-box no-gutters">
                <slot></slot>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    props: ['id']
}
</script>
